import { PolymerElement, html } from '@polymer/polymer/polymer-element.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@polymer/app-layout/app-drawer/app-drawer.js';
import '@polymer/paper-dropdown-menu/paper-dropdown-menu.js';
import '@polymer/paper-listbox/paper-listbox.js';
import '@polymer/paper-button/paper-button.js';
import '@polymer/paper-card/paper-card.js';
import '@polymer/paper-item/paper-item.js';
/**
 * `cbar-compass-filters` is an element that allows for the searching on the compass page within campaign-central to be filtered by a bunch of different
 * parameters, these being slotted in by the user.
 *
 * The expected properties set on the inputs or slotted elements are as follows
 *  - data-filter-name for the type of filter wishing to put on the search
 *  - data-filter-value for the value of the filter that will be used
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarCompassFilters extends PolymerElement {
  static get template() {
    return html`
        <style include="cbar-shared-styles">
            :host {
                display: block;
            }

            #content-box {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 0;
                height: 100%;
                width: 100%;
                float: left;
            }

            #card {
                opacity: 0;
                margin-top: -200px;
                height: var(--compass-filter-panel-height, 100%);
                background-color: var(--compass-filters-panel-background, white);
                width: 100%;
            }

            [hidden] {
                display: none;
            }

            paper-dropdown-menu {
                margin-left: 4%;
                margin-right: 4%;
                width: 16%;
            }

            @keyframes fadeIn {
                from {
                    opacity: 0;
                    margin-top: -200px;
                }
                to {
                    opacity: 1;
                    margin-top: 0;
                }
            }

            @keyframes fadeOut {
                from {
                    opacity: 1;
                    margin-top: 0;
                }
                to {
                    opacity: 0;
                    margin-top: -200px
                }
            }

            h2 {
                text-align: center;
            }

            .section-div {
                display: inline-block;
                margin-bottom: 2%;
            }

            .buttons-div {
                display: flex;
                justify-content: flex-end;
            }
            paper-card{
            z-index: 1;
            }

            @media (max-width: 600px) {
                h2 {
                    display: none;
                }
            }
        </style>
        <paper-card id="card" elevation="[[cardElevation]]" hidden>
            <div class="card-content" id="content-box">
                <template is="dom-if" if="[[!noTitle]]"> 
                    <h2>Filters</h2>
                </template>
                <div class="section-div">
                    <slot id="slotted">
                    </slot>
                </div>
            </div>
            <div class="buttons-div card-actions">
                    <paper-button class="flat-button" on-tap="toggleBox">Cancel</paper-button>
                    <paper-button class="flat-button" on-tap="_fireSearch">Search</paper-button>
            </div>

        </paper-card>
`;
  }

  static get is() {
    return 'cbar-compass-filters';
  }

  static get properties() {
    return {
      /**
       * Property that controls the animation and visibility of the card, if false the card is hidden (default) or if true the card will
       * move to be visible.
       */
      boxToggled: {
        type: Boolean,
        value: false,
        observer: '_boxToggledChanged',
      },
      cardElevation: {
        type: String,
        value: '0'
      },
      noTitle: {
        type: Boolean,
        value: false
      }
    };
  }

  ready() {
    super.ready();

    this.$.card.addEventListener('animationend', () => {
      requestAnimationFrame(() => {
        // Hide the card after animating.
        this.$.card.hidden = !this.boxToggled;
      });
    })
  }

  /**
   * Function that fades out the box if the element is currently shown, fades in the box otherwise.
   */
  toggleBox() {
    this.boxToggled = !this.boxToggled;
  }

  /**
   * Function that fires a search-clicked event when the search button is pressed, sends out all of the selected values from the dropdowns
   * which can be handled and used externally by listening for the "search-clicked" event on the element.
   * @private
   */
  _fireSearch() {
    let slotted = this.$.slotted;
    let values = [];

    // Run through all of the nodes that have been slotted in, if the node is not a text node, get the value and name of the element, and add it to the value array
    // NOTE: the data-filer-name and data-filter-value properties need to be set on each of the slotted elements to work correctly
    slotted.assignedNodes().forEach(node => {
      if(node.nodeType !== Node.TEXT_NODE) {
        let nodeProperty = node.dataset['filterName'];
        let nodeValue = node.dataset['filterValue'];
        values.push({property: nodeProperty, value: nodeValue});
      }
    });

    let searchFunction = new CustomEvent('search-clicked', {
      bubbles: true,
      composed: true,
      detail: values
    });

    this.toggleBox();
    this.dispatchEvent(searchFunction);
  }

  _boxToggledChanged(boxToggled) {
    if (boxToggled === true) {
      this.$.card.hidden = false;
      this.$.card.style.animation = "fadeIn 0.5s forwards";
    }else {
      this.$.card.style.animation = "fadeOut 0.5s forwards";
    }
  }
}

window.customElements.define(CbarCompassFilters.is, CbarCompassFilters);
